<div class="card">
    <div class="card-header d-flex align-tems-center justify-content-between">
        <div>
            <button class="btn btn-light btn-sm" (click)="expanded = !expanded">
                @if (expanded) {
                    <span class="dripicons-chevron-up"></span>
                }
                @if (!expanded) {
                    <span class="dripicons-chevron-down"></span>
                }
            </button>
            Sales Setup
        </div>

        <button [disabled]="loading || form.invalid || !entityId" class="btn btn-sm btn-primary float-right" (click)="save()">{{ words[language][ 'save' ]}}</button>
    </div>
    @if (expanded) {
        <div class="card-body">
            <div class="row text-dark">
                <div class="col-5">
                    <h5>Presets &amp; Defaults</h5>
                    <form id="sales-setup-defaults" [formGroup]="form">
                        <div class="form-group row">
                            <label for="enableBHPH" class="col col-form-label">In-House Financing (BHPH)</label>
                            <select class="col form-control form-control-sm" id="enableBHPH" formControlName="enableBHPH">
                                <option value="true">Enabled (on)</option>
                                <option value="false">Disabled (no in-house financing)</option>
                            </select>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" for="defaultSaleStageId">Default Sale Type</label>
                            <select class="col form-control form-control-sm" id="defaultSaleTypeId" formControlName="defaultSaleTypeId">
                                @for (id of saleTypeKeys; track id) {
                                    <option [value]="id">{{saleTypes[id]}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" for="sellerFinanceNumber">Seller Finance Number</label>
                            <number-input [id]="'sellerFinanceNumber'" [control]="form.get('sellerFinanceNumber')"></number-input>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" for="defaultBHPHTaxMethod">Default Tax Method</label>
                            <select class="col form-control form-control-sm" id="defaultBHPHTaxMethod" formControlName="defaultBHPHTaxMethod">
                                @for (method of taxMethodKeys; track method) {
                                    <option [value]="method">{{taxMethods[method]}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" for="defaultBHPHPaymentCycle">Default Payment Cycle</label>
                            <select class="col form-control form-control-sm" id="defaultBHPHPaymentCycle" formControlName="defaultBHPHPaymentCycle">
                                @for (cycle of paymentCycles | keyvalue; track cycle) {
                                    <option [value]="cycle.key">{{cycle.value}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" for="defaultLienholderContactId">Default BHPH Lienholder</label>
                            <div class="col">
                                <contact-advanced-search key="bhph-default-lienholder" type="lienholder" [displayLabel]="false"
                                    [contactIdSaved]="form.get('defaultLienholderContactId').value"
                                    (setContactId)="setContactIdEvent($event)">
                                </contact-advanced-search>
                            </div>                            
                        </div>
                        <h5>APR Maximum Values for Motor Vehicle (MV) Loans</h5>
                        <div class="form-group row">
                            <label for="setDealerMaximums" class="col col-form-label">Use Dealer Maximums</label>
                            <select class="col form-control form-control-sm" id="setDealerMaximums" formControlName="setDealerMaximums">
                                <option value="true">Enabled (specify below)</option>
                                <option value="false">Disabled (off)</option>
                            </select>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" for="apr5Over">5 Years and Older</label>
                            <percent-input [id]="'apr5Over'" [control]="form.get('apr5Over')"></percent-input>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" for="apr3To4">3 and 4 Years Old</label>
                            <percent-input [id]="'apr3To4'" [control]="form.get('apr3To4')"></percent-input>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" for="aprBelow2">2 Years and Newer</label>
                            <percent-input [id]="'aprBelow2'" [control]="form.get('aprBelow2')"></percent-input>
                        </div>
                        <h5>Mature Motor Vehicle (MV) Loans</h5>
                        <div class="form-group row">
                            <label for="acrueAfterMaturity" class="col col-form-label">Acrue Interest After <abbr title="Motor Vehicle">MV</abbr> Loan Maturity</label>
                            <select class="col form-control form-control-sm" id="acrueAfterMaturity" formControlName="acrueAfterMaturity">
                                <option value="true">Enabled (on)</option>
                                <option value="false">Disabled (no interest after maturity)</option>
                            </select>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" for="aprMatureSIE">Mature SIE Loans</label>
                            <percent-input [id]="'aprMatureSIE'" [control]="form.get('aprMatureSIE')"></percent-input>
                        </div>
                    </form>
                </div>
                <div class="col">
                    <section>
                        <h5>Setup Default Dealer Fees</h5>
                        <form [formGroup]="feeForm">
                            <ng-container formArrayName="fees">
                                <table class="table table-hover table-striped">
                                    <thead>
                                        <th scope="col">Fee</th>
                                        <th scope="col" style="width: 11em;" class="text-right">Amount</th>
                                        <th scope="col">Note</th>
                                        <th scope="col"></th>
                                    </thead>
                                    @for (feeGroup of fees.controls; track feeGroup; let i = $index) {
                                        <tbody>
                                            <tr [formGroup]="feeGroup">
                                                <td><input type="text" class="form-control form-control-sm" formControlName="name" [readonly]="((feeGroup.get('feeId').value != null) && (feeGroup.get('feeId').value > 0))" /></td>
                                                <td>
                                                    <input type="hidden" formControlName="id" />
                                                    <input type="hidden" formControlName="feeId" />
                                                    <div class="input-group input-group-sm">
                                                        @if (!feeGroup.get('rate').value) {
                                                            <div class="input-group-prepend"><span class="input-group-text material-icons">attach_money</span></div>
                                                        }
                                                        @if (feeGroup.get('editable').value) {
                                                            <input type="text" class="form-control form-control-sm text-right" formControlName="amount" />
                                                        }
                                                        @if (!feeGroup.get('editable').value) {
                                                            <input type="text" class="form-control form-control-sm text-right" formControlName="default" [value]="feeGroup.get('default').value | number:'1.2-6'" readonly />
                                                        }
                                                        @if (feeGroup.get('rate').value) {
                                                            <div class="input-group-append"><span class="input-group-text">%</span></div>
                                                        }
                                                    </div>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control form-control-sm" formControlName="description" />
                                                </td>
                                                <td>
                                                    @if (!loading && ((feeGroup.invalid) || (feeGroup.pristine)) && ((feeGroup.get('feeId').value == null) || (feeGroup.get('feeId').value <= 0))) { 
                                                        <button title="Delete" class="btn btn-sm btn-link" (click)="discardFee(i)"><span class="dripicons dripicons-trash text-danger"></span></button>
                                                    }
                                                    @if (!loading && feeGroup.valid && feeGroup.dirty && feeGroup.get('editable').value) {
                                                        <button title="Save" class="btn btn-sm btn-link" (click)="saveFee(i)"><span class="dripicons dripicons-cloud-upload text-primary"></span></button>
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    }
                                    @empty {
                                        <tbody><tr><td colSpan="4"><div class="alert alert-warning mt-1">Add a <strong>lot address</strong> to get started managing sale fees.</div></td></tr></tbody>
                                    }
                                </table>
                            </ng-container>
                        </form>
                        <div class="fee-button-bar">
                            <button type="button" class="btn btn-success btn-sm" (click)="addFee()" id="addFee"><span class="dripicons dripicons-plus"></span></button>
                            @if (fees.dirty) {
                            <button type="button" class="btn btn-primary btn-sm" (click)="saveAllFees()" id="saveAllFees">
                                @if (saving) {
                                    <span class="spinner-grow spinner-grow-sm" role="status"></span>
                                }
                                @if (!saving) {
                                    <span class="dripicons dripicons-cloud-upload"></span>
                                }
                                Save All
                            </button>
                            }
                        </div>
                    </section>
                </div>
            </div> <!-- row-->
            <div class="card shadow-none">
                <div class="card-header">Related Links</div>
                <div class="card-body">
                    <ul>
                        <li><a href="https://www.txdmv.gov/dealers" target="_blank">Texas Dealer FAQs, Forms, and Publications</a></li>
                        <li><a href="https://www.txdmv.gov/motorists" target="_blank">Texas Motorist FAQs, Forms, and Manuals</a></li>
                        <li><a href="https://statutes.capitol.texas.gov/Docs/FI/htm/FI.348.htm" target="_blank">Texas Finance Code - Motor Vehicle Retail Sales</a></li>
                        <li><a href="https://comptroller.texas.gov/taxinfo/local/" target="_blank">Texas Sales Tax Information</a></li>
                        <li><a href="https://www.txdmv.gov/node/4864" target="_blank">Texas Vehicle Registration Fee Charts</a></li>
                        <li><a href="https://comptroller.texas.gov/forms/ap-169.pdf" target="_blank">Seller Finance Sales Tax Application</a></li>
                        <li><a href="https://occc.texas.gov/industry/motor-vehicle-sales-finance-mvsf/rate-charts" target="_blank">OCCC Motor Vehicle Loan Interest Rate Chart</a></li>
                    </ul>
                </div>
            </div>
        </div>
    }
    <!-- </div> -->
</div>
